enum Classification {
    Administrator = 'Administrator',
    Other = 'Other',
}

export default Classification;
